module.exports = __webpack_public_path__ + "static/media/alberto.656648df.jpg";